/* eslint-disable max-len */
import 'react';

const SelectAllEntrySvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2.6665" width="4" height="4" rx="0.666667" stroke="#11141A" />
        <rect x="2" y="9.3335" width="4" height="4" rx="0.666667" stroke="#11141A" />
        <rect x="8" y="4.3335" width="6.66667" height="1" rx="0.5" fill="#11141A" />
        <rect x="8" y="11" width="6.66667" height="1" rx="0.5" fill="#11141A" />
    </svg>

);
export default SelectAllEntrySvg;
